import { render, staticRenderFns } from "./BroadcastsPage.vue?vue&type=template&id=9d151e80&scoped=true"
import script from "./BroadcastsPage.vue?vue&type=script&lang=js"
export * from "./BroadcastsPage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastsPage.vue?vue&type=style&index=0&id=9d151e80&prod&lang=scss&scoped=true"
import style1 from "./BroadcastsPage.vue?vue&type=style&index=1&id=9d151e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d151e80",
  null
  
)

export default component.exports